import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

/**
 * Firebase Web SDK — initialised once at app boot. Reuses the same Firebase
 * project as cms-admin (leaply-cms-admin per `.firebaserc`) so admin users
 * sign in with the existing CMS credentials and the api's `cms_users`
 * whitelist applies (architecture §5.3).
 *
 * The env vars come from the Firebase console → Project settings → Web app.
 * Missing values throw at boot — fail-fast is better than a confusing
 * "auth/invalid-api-key" three clicks in.
 */
function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`Missing required env var: ${name}`);
  }
  return value;
}

export const app = initializeApp({
  apiKey: required("VITE_FIREBASE_API_KEY", import.meta.env.VITE_FIREBASE_API_KEY),
  authDomain: required(
    "VITE_FIREBASE_AUTH_DOMAIN",
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  ),
  projectId: required(
    "VITE_FIREBASE_PROJECT_ID",
    import.meta.env.VITE_FIREBASE_PROJECT_ID,
  ),
});

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
